import { Flex } from "@mantine/core";
import {
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import React from "react";

import { formatLegacyCompetencyColumns } from "./columns";
import { type ReviewPageBasicQuestion } from "@/types/screener-builder";

// This table is used for legacy screeners only
export const LegacyAssessmentQuestionTable = ({
  questions,
}: {
  questions: ReviewPageBasicQuestion[];
}) => {
  const columns = formatLegacyCompetencyColumns();
  const table = useReactTable({
    data: questions,
    columns: columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <Flex
      direction="column"
      className="bg-white p-6 border border-gray-200 rounded-md"
      gap="md"
    >
      <Flex
        className="w-full"
        direction="row"
        justify="space-between"
        align="center"
        gap="xs"
      >
        <Flex align="center" direction="row" gap="xs">
          <h2 className="text-lg font-semibold">Assessment Questions</h2>
        </Flex>
      </Flex>
      <div className="border border-gray-200 rounded-md overflow-x-auto">
        <table className="w-full">
          <thead className="text-xs uppercase">
            <tr>
              {table.getFlatHeaders().map((header) => (
                <th
                  key={header.id}
                  className="px-4 py-3 text-left font-semibold"
                  style={{ width: header.getSize() }}
                >
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext(),
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id} className={`border-t border-gray-200 h-14`}>
                {row.getVisibleCells().map((cell) => (
                  <td
                    key={cell.id}
                    className={`${
                      cell.column.id === "question" ? "pl-4 pr-0" : "px-4"
                    }`}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Flex>
  );
};
